/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { COMPONENT_OUTPUT_TYPE_JSON } from '../../ComponentOutput.entity.constant';
import { COMPONENT_OUTPUT_JSON_SCHEMA_DRAFT_07 } from './ComponentJsonOutput.entity.constant';

/**
 * The dxp component json output entity type.
 * @export
 */
export type EntityComponentJsonOutput = io.TypeOf<typeof ComponentJsonOutput>;

/**
 * The dxp component json output entity definition.
 * @export
 */
export const ComponentJsonOutput = io.type(
  {
    definition: io.literal(COMPONENT_OUTPUT_JSON_SCHEMA_DRAFT_07),
    responseType: io.literal(COMPONENT_OUTPUT_TYPE_JSON),
  },
  `ComponentJsonOutput`,
);
